export default __webpack_public_path__ + "static/media/RW.6c7fb7c3.svg";